export const arraySum = (array: number[]): number => {
  return array.reduce((prev, curr) => prev + curr);
};

export const maxIndex = (a: number[]) => {
  return a.indexOf(Math.max(...a));
};
export const minIndex = (a: number[]) => {
  return a.indexOf(Math.min(...a));
};

/**
 * A / Bをする。0割になる要素は0が入る
 * @param A 割られる数
 * @param B 割る数
 * @returns
 */
export const divisionByArray = (A: number[], B: number[]) => {
  if (A.length !== B.length) throw new Error("配列の長さを一致させてください");
  return A.map((a, i) => {
    const b = B[i];
    if (b === 0) return 0;
    return a / b;
  });
};
